import React, { useContext, useEffect, useState, useCallback } from 'react'
import { CheckoutContext } from './CheckoutContext'
import { Row, Col } from 'react-bootstrap';
import { formatCurrency } from 'util/Currency';
import { useLocation } from 'react-router-dom';
import { TenantContext } from 'tenant/TenantContext';
import { PaymentCartContext } from './PaymentCartContext';
import { Alert } from 'react-bootstrap';
import _ from "lodash";
import { extractError } from 'api/ErrorUtil';
import ElavonResult from './elavon/ElavonResult';
import StripeResult from './stripe/StripeResult';
import { formatDate } from 'util/Date';
import { evenRound } from 'util/NumberUtils';
import { FormContainer } from 'uiwidgets/FormContainer';
import BillFragment from './BillFragment';
import DonationFragment from './DonationFragment';
import OfflinePaymentResult from './offline/OfflinePaymentResult';

const CheckoutResult = () => {

    const { businessConfig } = useContext(TenantContext);
    const { paymentData } = useContext(CheckoutContext);
    const location = useLocation();
    const { emptyCart } = useContext(PaymentCartContext);
    const [formData, setFormData] = useState({})
    const [errors, setErrors] = useState({})

    const setupToDisplayResults = useCallback(async () => {
        setFormData(location.state?.formData);
        emptyCart();
        //disable being able to go back using back arrow key
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', function (event) {
            window.history.pushState(null, document.title, window.location.href);
        });
    })

    useEffect(() => {
        setupToDisplayResults().catch(err => {
            setErrors(extractError(err));
            setFormData(location.state?.formData);
        });

    }, [paymentData])

    return (
        <>
            {paymentData.paymentResult === 'PAYMENT_SUCCEEDED' && <Alert key="successalert">Payment was successful. </Alert>}
            {paymentData.paymentResult === 'PAYMENT_PENDING_APPROVAL' && <Alert key="successalert">Payment info was submitted successfully. It is pending approval from admin. </Alert>}
            {paymentData.paymentResult === 'PAYMENT_PROCESSING' && <Alert key="successalert">Payment info was submitted successfully. It is being processed. Check Payment History for the result. </Alert>}
            {!_.isEmpty(paymentData.paymentResponse) && <FormContainer title="Payment Results">
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
                {formData.paymentCartItems && formData.paymentCartItems.map((paymentCartItem, idx) => (
                    <React.Fragment key={idx}>
                        {(paymentCartItem.commitmentType === 'BILL') && <BillFragment paymentCartItem={paymentCartItem} idx={idx} key={'bill' + idx} allowDelete={false} />}
                        {(paymentCartItem.commitmentType === 'DONATION') && <DonationFragment paymentCartItem={paymentCartItem} idx={idx} key={'donation' + idx} allowDelete={false} />}
                    </React.Fragment>
                ))}
                {((businessConfig.businessFee.feePayer === 'CUSTOMER_OPTIONAL' && formData.customerConsentsToPayPfFees) || (businessConfig.businessFee.feePayer === 'CUSTOMER_MANDATORY')) &&
                    <Row>
                        <Col>
                            <div className="bill-line"><span>Transaction charge</span></div>
                        </Col>
                        <Col>
                            <div className="bill-line"><span>{formatCurrency(parseFloat(formData.platformFee / 100), businessConfig.locale, businessConfig.currency)}</span></div>
                        </Col>
                    </Row>}
                <Row>
                    <Col>&nbsp;</Col>
                </Row>
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="bill-total"><span>Total Payment</span></div>
                    </Col>
                    <Col>
                        <div className="bill-total"><span>
                            {formatCurrency(evenRound(parseFloat(paymentData.paymentResponse.totalPaymentAmount) / 100, 2), businessConfig.locale, businessConfig.currency)}
                        </span></div>
                    </Col>
                </Row>
                <Row>
                    <Col>Payment Date</Col>
                    <Col>{formatDate(paymentData.paymentResponse.paymentDate, businessConfig.locale)}</Col>
                </Row>
                <Row>
                    <Col>Transaction Number</Col>
                    <Col>{paymentData.paymentResponse.transactionNumber}</Col>
                </Row>
                <Row>
                    <Col>
                        {businessConfig.paymentGateway === 'ELAVON' && <ElavonResult paymentResult={{ formData, paymentData }} />}
                        {businessConfig.paymentGateway === 'STRIPE' && <StripeResult paymentResult={{ formData, paymentData }} />}
                    </Col>
                </Row>
                <Row>
                    <Col>&nbsp;</Col>
                </Row>
                <Row>
                    <Col>
                        {formData.paymentSourceType === 'OFFLINE' && <OfflinePaymentResult domain={businessConfig.subdomain} />}
                    </Col>
                </Row>

            </FormContainer>}

        </>
    )
}

export default CheckoutResult